import Vue from 'vue';
import $ from 'jquery';

let initWindowWidth = $(window).outerWidth();

export default () => {
  const bzBeltVm = new Vue({
    el: '.bz-belt',
    data() {
      return {
        nowScrollPosition: 0,
        beltTopShow: true,
        beltTopToggle: false,
        beltToggle: false,
        beltHidden: true,
        nowIsFeature: '',
        nowIsIndex: '',
      };
    },

    created() {
      window.addEventListener('scroll', this.handleScroll);
      this.nowFullpageUnit = window.location.href;
      this.getUnitName();
    },

    mounted() {
      window.addEventListener('resize', () => {
        initWindowWidth = $(window).outerWidth();
      });
      setTimeout(() => {
        this.nowIsFeature = $('body').hasClass('unit-feature');
        this.nowIsIndex = $('body').hasClass('fp-viewing-0');
      });
      // 監聽Class
      const mutationObserver = new MutationObserver(((mutations) => {
        mutations.forEach(() => {
          if (initWindowWidth > 1024 && ($('body').hasClass('fp-viewing-0') || $('body').hasClass('fp-viewing-banner'))) {
            this.beltTopShow = true;
          } else if (initWindowWidth > 1024 && (this.nowIsFeature || this.nowIsIndex)) {
            this.beltTopShow = false;
          }
          // }
        });
      }));

      mutationObserver.observe($('body')[0], {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
        attributeOldValue: true,
        characterDataOldValue: true,
      });
    },

    methods: {
      handleScroll() {
        const nowScrollPosition = window.pageYOffset;
        this.nowScrollPosition = Math.round(nowScrollPosition);
      },

      beltClick(type) {
        if (type === 'top' && !this.beltTopToggle) {
          this.beltTopToggle = true;
        } else if (type === 'top' && this.beltTopToggle) {
          this.beltTopToggle = false;
        }
      },

      getUnitName() {
        if (initWindowWidth < 768 && this.nowIsFeature) {
          this.beltHidden = true;
        } else {
          this.beltHidden = false;
        }
      },
    },

    watch: {
      nowScrollPosition(newValue) {
        if (newValue > 0) {
          this.beltTopShow = false;
        } else {
          this.beltTopShow = true;
        }
      },
    },

  });
  return bzBeltVm;
};
